import React, { useState } from "react";
import * as R from "ramda";
import CSSModules from "react-css-modules";
import CheckBox from "material-ui/Checkbox";
import css from "./style.scss";
import { actions, getters } from "../model";
import { connect } from "react-redux";
import { getLanguageProperties } from "../selectors";

const decorate = R.compose(
  connect(
    (state, props) => ({
      languageProps: getLanguageProperties(state, props),
      name: getters.name(state, props)
    }),
    {
      setFieldLanguageEnabled: actions.setFieldLanguageEnabled,
      setFieldLanguageName: actions.setFieldLanguageName
    }
  ),
  CSSModules(css)
);

const earthSvg = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
  >
    <g clipPath="url(#clip0_8676_4577)">
      <path
        d="M6.99971 1.16669C3.77972 1.16669 1.16638 3.78002 1.16638 7.00002C1.16638 10.22 3.77972 12.8334 6.99971 12.8334C10.2197 12.8334 12.833 10.22 12.833 7.00002C12.833 3.78002 10.2197 1.16669 6.99971 1.16669ZM2.33305 7.00002C2.33305 6.64419 2.37972 6.29419 2.45555 5.96169L5.24388 8.75002V9.33335C5.24388 9.97502 5.76888 10.5 6.41055 10.5V11.6259C4.11805 11.3342 2.33305 9.37419 2.33305 7.00002ZM10.4355 10.15C10.2839 9.67752 9.85221 9.33335 9.32722 9.33335H8.74388V7.58335C8.74388 7.26252 8.48138 7.00002 8.16055 7.00002H4.66055V5.83335H5.82721C6.14805 5.83335 6.41055 5.57085 6.41055 5.25002V4.08335H7.57721C8.21888 4.08335 8.74388 3.55835 8.74388 2.91669V2.67752C10.453 3.36585 11.6664 5.04585 11.6664 7.00002C11.6664 8.21335 11.1939 9.32169 10.4355 10.15Z"
        fill="#1E62D8"
      />
    </g>
    <defs>
      <clipPath id="clip0_8676_4577">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ChevronSvg = ({ expanded }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    style={{ transform: expanded ? "rotate(180deg)" : undefined }}
  >
    <g clipPath="url(#clip0_8753_960)">
      <path
        d="M9.6775 5.0108L7 7.68247L4.3225 5.0108L3.5 5.8333L7 9.3333L10.5 5.8333L9.6775 5.0108Z"
        fill="#1E62D8"
      />
    </g>
    <defs>
      <clipPath id="clip0_8753_960">
        <rect width="14" height="14" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const LanguageVariants = ({
  languageProps,
  setFieldLanguageEnabled,
  setFieldLanguageName,
  name
}) => {
  const [expanded, setExpanded] = useState(false);
  const variants = R.propOr([], "variants", languageProps);

  return (
    <>
      <div
        style={{
          color: "#1E62D8",
          fontSize: 14,
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "normal",
          cursor: "pointer",
          display: "flex",
          alignItems: "center",
          margin: expanded ? "8px 0 5px" : "8px 0 12px"
        }}
        onClick={() => {
          setExpanded(!expanded);
        }}
      >
        {earthSvg}&nbsp;Language variants <ChevronSvg expanded={expanded} />
      </div>
      {expanded && (
        <div
          style={{
            padding: "15px 20px",
            border: "1px solid #eee",
            borderRadius: "2px",
            backgroundColor: "#fafafa"
          }}
        >
          {variants.map((i, idx) => {
            return (
              <div
                style={{
                  marginBottom: variants.length - 1 === idx ? 0 : "16px"
                }}
                key={R.prop("code", i)}
              >
                <label styleName="formLabel">
                  {R.prop("label", i) + " - " + R.prop("code", i)}
                </label>
                <input
                  autoFocus
                  key="name"
                  styleName="input"
                  type="text"
                  value={R.prop("value", i)}
                  placeholder={name}
                  required="required"
                  onChange={ev =>
                    setFieldLanguageName({
                      language: i.code,
                      name: ev.target.value
                    })
                  }
                />
                <div
                  style={{
                    marginTop: "3px",
                    display: "flex",
                    alignItems: "center"
                  }}
                >
                  <CheckBox
                    checked={R.prop("show", i)}
                    onClick={() => {
                      setFieldLanguageEnabled({
                        language: i.code,
                        enabled: !i.show
                      });
                    }}
                    disabled={false}
                    style={{ width: "28px", display: "block" }}
                  />
                  <span style={{ fontSize: "13px" }}>Show this variant</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </>
  );
};

export default decorate(LanguageVariants);
